import React from "react";
import {StudentApprovalRow} from "./StudentApprovalRow";
import {GridTable, ResultsPager} from "../../../Components/Grid";
import {isArrayNullOrEmpty} from "../../../Utilities/Types/arrayUtilities";

interface StudentApprovalViewProps {
    handleSetStudentSearchCriteria: (criteria: Record<string, unknown>) => void;
    redirect: (path: string) => void;
    students: Record<string, any>[];
    studentSearchCriteria: Record<string, any>;
    totalRecords: number;
}

export const StudentApprovalView: React.FC<StudentApprovalViewProps> = ({
                                        handleSetStudentSearchCriteria,
                                        redirect,
                                        students,
                                        studentSearchCriteria,
                                        totalRecords
                                    }) => {

    const handleOrderClick = (event: React.MouseEvent<HTMLTableCellElement>) => {
        event.preventDefault();
        let criteria = {...studentSearchCriteria} as Record<string, unknown>;
        (criteria as { UpdateSorting: (id: string) => void }).UpdateSorting((event.target as HTMLElement).dataset.id!);
        handleSetStudentSearchCriteria(criteria);
    };

    const handleFirstClick = () => {
        let criteria = {...studentSearchCriteria};
        criteria.First();
        handleSetStudentSearchCriteria(criteria);
    };
    const handlePreviousClick = () => {
        let criteria = {...studentSearchCriteria};
        criteria.Previous();
        handleSetStudentSearchCriteria(criteria);
    };
    const handleNextClick = () => {
        let criteria = {...studentSearchCriteria};
        criteria.Next();
        handleSetStudentSearchCriteria(criteria);
    };
    const handleLastClick = () => {
        let criteria = {...studentSearchCriteria};
        criteria.Last(totalRecords);
        handleSetStudentSearchCriteria(criteria);
    };
    const pager = (isSecondaryPager: boolean) => <ResultsPager
        handleFirstClick={handleFirstClick}
        handlePreviousClick={handlePreviousClick}
        handleNextClick={handleNextClick}
        handleLastClick={handleLastClick}
        isSecondaryPager={isSecondaryPager}
        totalRecords={totalRecords}
        recordsPerPage={studentSearchCriteria.recordsPerPage}
        currentPage={studentSearchCriteria.page}
        disabled={false}
    />;


    const noResults = isArrayNullOrEmpty(students);

    return <>
        {pager(false)}
        <GridTable className="searchResults">
            <thead>
            <tr>
                <th onClick={handleOrderClick} className="is-clickable" data-id="fullName">Name</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="fimcStudentId">Student Id</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="dateOfBirth">Date of Birth</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="dateCreatedUtc">Date
                    Enrolled
                </th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="dateModifiedUtc">Date
                    Modified
                </th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="gradeLevelDescription">Grade Level</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="primaryReadingMedium">Prm</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="districtName">District</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="userFullName">Patron Name</th>
                <th onClick={handleOrderClick} className="is-clickable"
                    data-id="hasSignedParentalConsentOutput">Parental Consent
                </th>
                <th onClick={handleOrderClick} className={"is-clickable text-center"}
                    data-id="studentApprovalStatus"
                    scope={"col"}>Approval Status
                </th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="eligibility">Eligibility</th>
                <th scope={"col"} className={"align-center"}>
                    Actions
                </th>
            </tr>
            </thead>
            <tbody>
            {students.map((student) => {
                return (<StudentApprovalRow
                    key={student.studentId}
                    redirect={redirect}
                    student={student}
                />);
            })}
            {noResults && <tr data-testid={`no-users-row`}>
                <td colSpan={14} className={`text-center`}>No results found.</td>
            </tr>}
            </tbody>
        </GridTable>
        {pager(true)}
    </>;
}